import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ITrucks } from '../interfaces/trucks';
import { ITrucksFilter } from '../interfaces/trucks-filter';
import { EditService } from './edit.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class TrucksService extends EditService<ITrucks, ITrucksFilter> {
  url = '/api/trucks';
  entityTitle = 'Truck';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  create(truck: ITrucks): Promise<any> {
    //console.log(truck)
    let successMsg = 'Truck added.';

    const headers = new HttpHeaders({ 'Content-Type': 'application/json;charset=utf-8' });
    return this.handleRequest(
      this.http.post(this.url + '/save', truck, { headers: headers }),
      this.handlersFactory.getForCreate(this.entityTitle),
      successMsg,
    );
  }

  public GetByRegNum(regNum: string): Promise<any> {
    return this.handleRequest(
      this.http.get<ITrucks>('api/trucks/searchByRegNum?regNum=' + regNum),
      this.handlersFactory.getForReadAll(),
    );
  }

  getTruckTypes(): Promise<any> {
    return this.handleRequest(
      this.http.get<any>('api/trucks/truckTypes'),
      this.handlersFactory.getForReadAll(),
    );
  }

  getAll(supplierId): Promise<any> {
    return this.handleRequest(
      this.http.get<ITrucks[]>(`${this.url}` + '/getAll/' + supplierId),
      this.handlersFactory.getForReadAll(),
    );
  }

  getAccessDetails(truckId: number): Promise<any> {
    return this.handleRequest<any>(
      this.http.get<any>(this.url + '/accessDetails/' + truckId),
      this.handlersFactory.getForReadById(this.entityTitle),
    );
  }
}
